import { Textarea } from "@mantine/core";
import { useMemo } from "react";
import { useController } from "react-hook-form";
import { useInputProps } from "src/generator/hooks/useInputProps";
import MultipleAttachments, {
  IInEntryFile,
} from "src/generator/MultipleAttachments/MultipleAttachments";
import { Flex } from "src/styled";

interface Props {
  id: string;
  value: { text: string; files: IInEntryFile[] } | string;
}
const MedAttachedInput = ({ id, value }: Props) => {
  const defaultValue = useMemo(() => {
    if (typeof value === "string") return { text: "", files: [] };
    return value;
  }, [value]);

  const textField = useInputProps(`${id}.text`, defaultValue.text);
  const { field: filesField } = useController({
    name: `${id}.files`,
    defaultValue: defaultValue.files,
  });
  return (
    <Flex direction="column" gap={5}>
      <Textarea autosize minRows={1} miw={400} {...textField} />
      <MultipleAttachments
        value={filesField.value}
        id={`${id}.files`}
        btnText="Add File"
      />
    </Flex>
  );
};
export default MedAttachedInput;
